<template>
    <div class="Outer-frame">
          <el-container style="min-width:1280px;">
                <el-main>
                    <div class="main">
                        <div class="mainheader">
                            <span class="titlesp">
                                广东莫比科技有限公司
                            </span>
                            <span class="subtitlesp">
                                我们秉承“服务至上”的理念，诚心诚意为用户提供精准、优质的服务
                            </span>
                        </div>
                        <div class="mainmiddle">
                            <div class="contactus">
                                <div class="contactustitle">
                                    <p>联系我们</p>
                                </div>
                                <div class="contactuscontent">
                                    <p>联系电话：025-83728416</p>
                                    <p>客服微信：njmobii01</p>
                                    <p>9:00～18:00（周一至周五节假日除外）</p>
                                </div>
                            </div>
                            <div class="QRcode">
                                    <div class="QRcodecontent">
                                        <img src="../assets/images/mobiigw/bigweibo.png" alt="">
                                        <p>莫比！应用程序</p>
                                    </div>
                                    <div  class="QRcodecontent">
                                        <img src="../assets/images/mobiigw/wechat.png" alt="">
                                        <p>官方微信</p>
                                    </div>
                                    <div  class="QRcodecontent">
                                        <img src="../assets/images/mobiigw/gongzhonghao.png" alt="">
                                        <p>官方微信公众号</p>
                                    </div>
                                    <div  class="QRcodecontent">
                                        <img src="../assets/images/mobiigw/weibo.png" alt="">
                                        <p>官方微博</p>
                                    </div>
                            </div>
                        </div>
                    </div>
                </el-main>

                <el-footer>
                    <div class="footer">
                        <div class="footer-main">
                            <div class="footer-header">
                                <div class="footer-left">
                                    <div class="footer-left-title">
                                        <p>联系我们</p>
                                    </div>
                                    <div class="footer-left-content">
                                        联系电话：025-83728416
                                    </div>
                                    <div class="footer-left-content">
                                        官方微信：njmobii01
                                    </div>
                                    <div class="footer-left-content">
                                        官方邮箱：Mobii@justgoai.com
                                    </div>
                                </div>
                                <div class="footer-right">
                                    <div class="footer-right-title">
                                        关注我们
                                    </div>
                                    <div class="footer-right-content">
                                        <div class="footer-right-content-left">
                                            <img src="../assets/images/mobiigw/wechat.png" alt="">
                                            <p>APP下载</p>
                                        </div>
                                        <div class="footer-right-content-middle">
                                            <img src="../assets/images/mobiigw/gongzhonghao.png" alt="">
                                            <p>官方微信公众号</p>
                                        </div>
                                        <div class="footer-right-content-right">
                                            <img src="../assets/images/mobiigw/weibo.png" alt="">
                                            <p>官方微博</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="footer-middle">

                            </div>
                            <div class="footer-bottom">
                                <a href="http://beian.miit.gov.cn/" target="_blank">
                                    <p>版权所有 © 广东莫比科技有限公司 粤ICP备18159870号</p>
                                </a>

                            </div>
                        </div>
                    </div>
                </el-footer>
            </el-container>
    </div>
</template>
<script>
export default {

    data(){
        return{
            activeIndex:'contactus'

        }
    }
    // methods:{
    //     handleSelect(){

    //     },
    //     aboutus(){
    //         window.sessionStorage.clear();
    //         this.$router.push('/aboutus');
    //     }
    // }
}
</script>
<style scoped>
    .Outer-frame{
        min-width: 1280px;
        margin: 0px;
        padding: 0px;
        flex-direction: column;
    }

    .logo{
        margin-left: 13%;
        margin-top: 20px;
    }

    .el-menu-demo{
        float: right;
    }

    .el-main{
        padding: 20px 0;
    }

    .el-footer{
        margin-top: 156px;
        padding: 0 0;
    }

    .main{
        height: 100%;
        width: 100%;
    }

    .mainheader{
        width:100%;
        height:410px;
        background:rgba(4,120,90,1);
        display: flex;
        flex-direction: column;
    }

    .titlesp{
        font-size:36px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:50px;
        margin: 0 auto;
        margin-top: 156px;
    }

    .subtitlesp{
        height:28px;
        font-size:20px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:28px;
        margin: 0 auto;
        margin-top: 20px;
    }

    .mainmiddle{
        width: 71.11%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
    }

    .contactus{
        margin-top: 30px;
        width: 100%;
    }

    .contactustitle p{
        height:28px;
        font-size:20px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:900;
        color:rgba(0,0,0,1);
        line-height:28px;
    }

    .contactuscontent p{
        height:22px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:22px;
    }

    .contus{
        height:28px;
        font-size:20px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:28px;
        padding-inline-start: 0px;
    }

    .contusp{
        height:22px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:22px;
    }

    .QRcode{
        display: flex;
        justify-content: space-between;
        margin-top: 50px;
    }

    .QRcodecontent{
        text-align: center;
    }

    .QRcodecontent img{
        width: 140px;
        height: 140px;
    }

    .QRcodecontent p{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:20px;
    }

    .footer{
        width: 100%;
        height: 343px;
        background:rgba(129,129,129,1);
    }

    .footer-main{
        width: 71.11%;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
    }

    .footer-header{
        width: 100%;
        display: flex;
        flex-direction: row;
        margin: 0 auto;
    }

    .footer-left{
        width: 30%;
    }

    .footer-right{
        width: 70%;
    }

    .footer-left-title,.footer-right-title{
        height:30px;
        font-size:22px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:30px;
        margin-top: 44px;
    }

    .footer-left-content{
        height:20px;
        font-size:14px;
        font-family:"PingFangSC-Regular","PingFang SC";
        font-weight:400;
        color:rgba(221,221,221,1);
        line-height:20px;
        margin-top: 26px;
    }

    .footer-right-content{
        width: 70%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 26px;
        margin: 26px 0 0 -26px;
    }

    .footer-right-content img{
        width: 94px;
        height: 94px;
    }

    .footer-right-content-left,.footer-right-content-middle,.footer-right-content-right{
        margin: 0 auto;
        text-align: center;
    }

    .footer-right-content-left,.footer-right-content-middle,.footer-right-content-right p{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:20px;
    }

    .footer-middle{
        width: 100%;
        height: 1px;
        background-color: #aaaaaa;
        margin-top: 1%;
        margin-bottom: 1%;
    }

    .footer-bottom{
        margin: 0 auto;
    }

    .footer-bottom p{
        text-align: center;
        height: 21px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(221,221,221,1);
        line-height: 21px;
    }

    .el-menu{
        border-bottom: none;
    }

    a{
        text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// src/modules/contactus.vue